export default __webpack_public_path__ + "static/media/os_RockyLinux.2e88ccb9.svg";